import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileContract } from "@fortawesome/free-solid-svg-icons";

// ----------------------- POLICY REF BADGE ------------------------------------
export default function PolicyChip({ value }: { value: string | null | undefined }) {
  if (!value) return null;
  return (
    <span title="Policy reference" className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-indigo-500/10 px-2 py-0.5 font-mono text-[11.5px] font-semibold text-indigo-600 dark:text-indigo-300">
      <FontAwesomeIcon icon={faFileContract} className="text-[10px]" />
      {value}
    </span>
  );
}
